// Color palette และ theme constants
export const COLORS = {
	// Primary colors
	primary: "#1976d2",
	primaryLight: "#e3f0fd",
	primaryDark: "#0d47a1",

	// Status colors
	success: "#19a24bff",
	successLight: "#ccf9dcff",
	successDark: "#168740ff",

	danger: "#dc2626",
	dangerLight: "#fee2e2",
	dangerDark: "#b91c1c",

	warning: "#f59e0b",
	warningLight: "#fef3c7",
	warningDark: "#d97706",

	info: "#3b82f6",
	infoLight: "#dbeafe",
	infoDark: "#1d4ed8",

	// Neutral colors
	gray50: "#f9fafb",
	gray100: "#f3f4f6",
	gray200: "#e5e7eb",
	gray300: "#d1d5db",
	gray400: "#9ca3af",
	gray500: "#6b7280",
	gray600: "#4b5563",
	gray700: "#374151",
	gray800: "#1f2937",
	gray900: "#111827",

	// Background colors
	background: "#f5f6fa",
	backgroundLight: "#f8fafd",
	white: "#ffffff",

	// Border colors
	border: "#e0e0e0",
	borderLight: "#f0f0f0",
	borderDark: "#d1d5db",
}

// Status color configurations
export const STATUS_COLORS = {
	active: {
		color: COLORS.success,
		backgroundColor: COLORS.successLight,
		borderColor: COLORS.successDark,
	},
	inactive: {
		color: COLORS.gray500,
		backgroundColor: COLORS.gray100,
		borderColor: COLORS.gray300,
	},
	expired: {
		color: COLORS.warning,
		backgroundColor: COLORS.warningLight,
		borderColor: COLORS.warningDark,
	},
	grace_period: {
		color: COLORS.warning,
		backgroundColor: COLORS.warningLight,
		borderColor: COLORS.warningDark,
	},
	cancelled: {
		color: COLORS.danger,
		backgroundColor: COLORS.dangerLight,
		borderColor: COLORS.dangerDark,
	},
	waiting: {
		color: COLORS.info,
		backgroundColor: COLORS.infoLight,
		borderColor: COLORS.infoDark,
	},
	success: {
		color: COLORS.success,
		backgroundColor: COLORS.successLight,
		borderColor: COLORS.successDark,
	},
	failed: {
		color: COLORS.danger,
		backgroundColor: COLORS.dangerLight,
		borderColor: COLORS.dangerDark,
	},
	pending: {
		color: COLORS.warning,
		backgroundColor: COLORS.warningLight,
		borderColor: COLORS.warningDark,
	},
	read: {
		color: COLORS.success,
		backgroundColor: COLORS.successLight,
		borderColor: COLORS.successDark,
	},
	unread: {
		color: COLORS.danger,
		backgroundColor: COLORS.dangerLight,
		borderColor: COLORS.dangerDark,
	},
	yes: {
		color: COLORS.success,
		backgroundColor: COLORS.successLight,
		borderColor: COLORS.successDark,
	},
	no: {
		color: COLORS.danger,
		backgroundColor: COLORS.dangerLight,
		borderColor: COLORS.dangerDark,
	},
	card_expired: {
		color: COLORS.danger,
		backgroundColor: COLORS.dangerLight,
		borderColor: COLORS.dangerDark,
	},
	info: {
		color: COLORS.info,
		backgroundColor: COLORS.infoLight,
		borderColor: COLORS.infoDark,
	},
}

// Typography
export const TYPOGRAPHY = {
	fontFamily: '"Segoe UI", Thonburi, Tahoma, Geneva, Verdana, sans-serif',
	fontSize: {
		xs: "10px", // Extra small
		sm: "12px", // Small (base size)
		md: "14px", // Medium
		lg: "16px", // Large
		xl: "18px", // Extra large
		"2xl": "20px", // 2X large
		"3xl": "24px", // 3X large
	},
	fontWeight: {
		normal: 400,
		medium: 500,
		semibold: 600,
		bold: 700,
	},
	lineHeight: {
		tight: 1.25,
		normal: 1.5,
		relaxed: 1.75,
	},
}

// Spacing
export const SPACING = {
	xs: "4px",
	sm: "8px",
	md: "16px",
	lg: "24px",
	xl: "32px",
	"2xl": "48px",
}

// Border radius
export const BORDER_RADIUS = {
	sm: "4px",
	md: "6px",
	lg: "8px",
	xl: "12px",
	full: "9999px",
}

// Shadows
export const SHADOWS = {
	sm: "0 1px 3px rgba(0, 0, 0, 0.1)",
	md: "0 2px 8px rgba(0, 0, 0, 0.1)",
	lg: "0 4px 16px rgba(0, 0, 0, 0.1)",
	xl: "0 8px 32px rgba(0, 0, 0, 0.15)",
}

// Breakpoints
export const BREAKPOINTS = {
	mobile: "600px",
	tablet: "900px",
	desktop: "1200px",
}
